(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-dom/client"));
	else if(typeof define === 'function' && define.amd)
		define("HCS", ["react", "react-dom", "react-dom/client"], factory);
	else if(typeof exports === 'object')
		exports["HCS"] = factory(require("react"), require("react-dom"), require("react-dom/client"));
	else
		root["HCS"] = factory(root["React"], root["ReactDOM"], root["ReactDOM"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__38036__, __WEBPACK_EXTERNAL_MODULE__6047__, __WEBPACK_EXTERNAL_MODULE__3765__) => {
return 